import { gql } from '@apollo/client';

export const GET_USER_ENTITY_PERMISSIONS = gql`
  query UserEntityPermissions($entityId: String!, $entityType: UserEntityPermissionType!) {
    userEntityPermissions(entityId: $entityId, entityType: $entityType) {
      id
      entityId
      entityType
      userId
      permissions
    }
  }
`;

export const UPDATE_USER_ENTITY_PERMISSION = gql`
  mutation UpdateUserEntityPermission($input: UpdateUserEntityPermissionInput!) {
    updateUserEntityPermission(input: $input)
  }
`;
